import React, { useEffect } from "react";
import Button from "./Button";

export default function DarkModal({ open, title, onClose, children, width = "min(900px, 96vw)", height = "80vh" }) {
  useEffect(() => {
    if (!open) return;

    const onKeyDown = (e) => {
      if (e.key === "Escape") onClose?.();
    };

    document.addEventListener("keydown", onKeyDown);
    return () => document.removeEventListener("keydown", onKeyDown);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div
      onClick={onClose}
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 9999,
        background: "rgba(15, 23, 42, 0.65)",
        backdropFilter: "blur(4px)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 16,
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          width,
          height,
          borderRadius: 14,
          border: "1px solid rgba(255,255,255,0.12)",
          background: "linear-gradient(180deg, #1e293b 0%, #334155 100%)",
          boxShadow: "0 20px 55px rgba(0,0,0,0.55)",
          color: "white",
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
        }}
      >
        {/* Header */}
        <div
          style={{
            padding: "12px 14px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            borderBottom: "1px solid rgba(255,255,255,0.10)",
            background: "rgba(255,255,255,0.04)",
          }}
        >
          <div style={{ fontWeight: 800, fontSize: 16 }}>{title}</div>

          <div style={{ display: "flex", gap: 8 }}>
            <Button variant="secondary" onClick={onClose}>Chiudi</Button>
          </div>
        </div>

        {/* Body */}
        <div style={{ padding: 14, overflow: "auto", flex: 1 }}>
          {children}
        </div>
      </div>
    </div>
  );
}